import React from 'react';
import { Link } from 'react-router-dom';

const NavigationLinks = () => {
  const links = [
    {text: "playlists", path: "/playlists"},
    {text: "submissions", path: "/submissions"},
    {text: "discord", path: "https://discord.gg/D3ngmymWQe", isExternal: true},
    {text: "shop", path: "/shop"}
  ];

  return (
    <nav className="hidden md:flex gap-6">
      {links.map(link => (
        link.isExternal ? (
          <a
            key={link.path}
            href={link.path}
            target="_blank"
            rel="noopener noreferrer"
            className="text-small font-label font-medium tracking-[0.15em] text-ink-mid hover:text-ink transition-colors"
          >
            {link.text}
          </a>
        ) : (
          <Link
            key={link.path}
            to={link.path}
            className="text-small font-label font-medium tracking-[0.15em] text-ink-mid hover:text-ink transition-colors"
          >
            {link.text}
          </Link>
        )
      ))}
    </nav>
  );
};

export default NavigationLinks;